import { VoohMediaFormat, VoohMediaNode } from '../VoohCampaignForm/types'
import { CreationSchedule } from '../../../types/campaign'

export interface VoohCreationEmission {
  creationId: string
  details: string
  duration: number
  mediaFormat: VoohMediaFormat
  thumbnailUrl: string
  campaign: {
    id: string
    startDate: string
    endDate: string
  }
  schedules: {
    show: boolean
    loading: boolean
    dates: CreationSchedule<string>[]
  }
  locations: {
    show: boolean
    mediums: VoohMediaNode[]
    selectedMediums: VoohMediaNode[]
    loading: boolean
  }
  frequency: {
    show: boolean
    hourFrequency: number
    loading: boolean
  }
  map: {
    show: boolean
    loading: boolean
  }
  file: {
    name: string
    url: string
  }
}

export const VoohCreationEmissionSliceEmpty: VoohCreationEmission = {
  creationId: '',
  details: '',
  duration: 0,
  mediaFormat: VoohMediaFormat.MOVE_TV,
  thumbnailUrl: '',
  campaign: {
    id: '',
    startDate: '',
    endDate: '',
  },
  schedules: {
    show: true,
    loading: false,
    dates: [],
  },
  locations: {
    show: false,
    mediums: [],
    selectedMediums: [],
    loading: false,
  },
  frequency: {
    show: true,
    hourFrequency: 0,
    loading: false,
  },
  map: {
    show: true,
    loading: false,
  },
  file: {
    name: '',
    url: '',
  },
}

export interface UpdateCreationSchedulePayload {
  creationId: string
  details: string
  duration: number
  mediaFormat: VoohMediaFormat
  campaign: VoohCreationEmission['campaign']
  schedules: VoohCreationEmission['schedules']['dates']
  hourFrequency: number
  mediums: VoohCreationEmission['locations']['mediums']
  selectedMediums: VoohCreationEmission['locations']['selectedMediums']
  thumbnailUrl: string
  file: {
    name: string
    url: string
  }
}
